import { z } from 'zod'

export const ResolveLocationInputSchema = z.object({
  customerId: z.number().int().positive(),
  address: z.string().min(1).max(500),
  name: z.string().max(255).optional(),
  addressLineTwo: z.string().max(100).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  customerRef: z.string().max(100).optional(),
  resolution: z.object({
    autoResolveThreshold: z.number().min(0).max(1).optional(),
    autoCreate: z.boolean().optional(),
    lookupOnly: z.boolean().optional(),
  }).optional(),
})

export const CreateLocationInputSchema = z.object({
  customerId: z.number().int().positive(),
  name: z.string().min(1).max(255),
  address: z.string().min(1).max(500),
  addressLineOne: z.string().max(255).optional(),
  addressLineTwo: z.string().max(100).optional(),
  city: z.string().max(100).optional(),
  state: z.string().max(100).optional(),
  zipCode: z.string().max(20).optional(),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  placeId: z.string().optional(),
  plusCode: z.string().max(20).optional(),
  regionId: z.number().int().positive().optional(),
  timezone: z.string().optional(),
  type: z.enum(['customer', 'consumer residential', 'consumer business', 'driver', 'driver home']).optional(),
  customerRef: z.string().max(100).optional(),
  coordinatesSource: z.enum(['geocoded', 'user_adjusted', 'imported']).optional(),
  geocodedLatitude: z.number().min(-90).max(90).optional(),
  geocodedLongitude: z.number().min(-180).max(180).optional(),
  placeIdAuthoritative: z.boolean().optional(),
})
